import type { CSSProperties } from 'react';

import { observer } from 'mobx-react';

import { Overlay } from '../../components/Overlay/Overlay';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { useStartGame } from '../../hooks/useStartGame';
import { analytics } from '../../services/analytics';
import { postRequest } from '../../services/api';
import type { Game } from '../../stores/game/types';
import { useStores } from '../../stores/useStores';

import styles from './Onboarding.module.scss';
import { GameTooltip } from './tooltips/GameTooltip';

export const GamesOnboarding = observer(
  (props: { setPopperElement: (el: HTMLElement | null) => void; tooltipStyles: CSSProperties; game: Game }) => {
    const { onboardingStore, userStore } = useStores();
    const { handleStartGame } = useStartGame();

    const handleClick = () => {
      onboardingStore.finishFtue();

      void postRequest('user/profile', { isOnboardingCompleted: true }).finally(() => {
        userStore.updateProfile({ isOnboardingCompleted: true });
        void analytics.sendEvent('onboarding_finished', {});
      });

      handleStartGame(props.game.masterCasinoGameId, 'popup');
    };

    return (
      <Overlay backdropClassName={styles.overlayBackdrop} className={styles.overlay}>
        <Tooltip setTooltipRef={props.setPopperElement} tooltipPositionStyle={props.tooltipStyles}>
          <GameTooltip handleClick={handleClick} />
        </Tooltip>
      </Overlay>
    );
  },
);
